import { defineAction } from '~/prix'
import alertUpdateAction from './alertUpdate.action.json' with { type: 'json' }
import { alertObject } from '../alertObject'
import { z } from 'zod'

const alertUpdateDefinition = defineAction({
  ...alertUpdateAction,

  input: alertObject,
  output: z.object({}),
})

export default alertUpdateDefinition
